import routes from "./routes";
import { useAuth } from "../auth/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function PrivateRouteWrapper({ children }) {
  const { logged, loadingLogged, activeCompany, loadingActiveCompany } =
    useAuth();
  const location = useLocation();

  if (loadingLogged) return <></>;
  if (!logged) return <CustomNavigate to={routes.Account.Login} />;

  if (loadingActiveCompany) return <></>;
  if (!activeCompany) {
    const allowedRoutesWhenNoActiveCompany = [
      routes.Company.root,
      routes.Settings.profile,
      routes.Settings.password,
    ];
    if (
      !allowedRoutesWhenNoActiveCompany.some((route) =>
        location.pathname.includes(route),
      )
    ) {
      return <Navigate to={routes.Company.root} replace />;
    }
  }

  return children;
}

function CustomNavigate({ to }) {
  useEffect(() => {
    window.location.href = to;
  }, [to]);

  return <></>;
}
